import { mcpEnUS } from "./mcp/en-US";

export default {
  mcp: mcpEnUS,
  integrations: "Integrations",
  slackIntegration: "Slack Integration",
  slackDescription:
    "Connect your Slack workspace to enable time tracking prompts for your team.",
  slackCardDescription:
    "Send time tracking prompts and collect entries via Slack.",
  notConnected: "Not connected",
  connected: "Connected",
  connectToSlack: "Connect to Slack",
  disconnect: "Disconnect",
  workspaceName: "Workspace",
  connectedBy: "Connected by",
  connectedOn: "Connected on",
  backToIntegrations: "Integrations",
  overview: "Overview",
  howItWorks: "How it works",
  slackOverviewText:
    "The Slack integration connects your workspace to Invup, enabling automated time tracking prompts directly in Slack. Team members receive daily reminders to log their hours without leaving Slack, keeping time entries accurate and up to date.",
  slackFeature1:
    "Automated daily time tracking prompts sent via Slack DM to each team member.",
  teamMembers: "Team members",
  slackFeature2:
    "can log time entries directly from Slack without opening Invup.",
  slackFeature3: "Admins can configure prompt schedules and working days from",
  organizationSettings: "organization settings",
  dailyPromptSettings: "Daily Prompt Settings",
  enableDailyPrompt: "Enable daily time tracking prompts",
  promptTime: "Prompt time",
  workingDays: "Working days",
  workingDaysHint: "Change working days in",
  promptSettingsSaved: "Daily prompt settings saved.",
  disconnectConfirmTitle: "Disconnect Slack",
  disconnectConfirmMessage:
    "This will stop all Slack time tracking prompts for your organization. Are you sure?",
  slackConnectedSuccess: "Slack workspace connected successfully.",
  slackConnectionError: "Failed to connect Slack workspace. Please try again.",
  slackWorkspaceTaken:
    "This Slack workspace is already connected to another organization.",
  slackConnectionCancelled: "Slack connection was cancelled.",
  slackDisconnectedSuccess: "Slack workspace disconnected.",
  slackDisconnectError:
    "Failed to disconnect Slack workspace. Please try again.",
  stripeCardDescription:
    "Accept card and bank payments on invoices through Stripe.",
  stripeIntegration: "Stripe Integration",
  stripeOverviewText:
    "Connect a Stripe account to let clients pay invoices online with cards and supported local payment methods. Stripe handles funds, payouts, and compliance; Invup hands off the payment intent and reconciles the result against the invoice.",
  connectStripeAccount: "Connect Stripe account",
  updateStripeAccount: "Update Stripe account",
  stripeAccount: "Stripe account",
  stripeReadyForUse: "Ready for payments",
  stripePendingRequirements: "Pending requirements",
  stripeNoAccountYet:
    "No Stripe account is connected to this organization yet. Click the button below to start onboarding with Stripe.",
  stripeFinishOnboarding:
    "Stripe still needs more information before this account can accept payments.",
  continueStripeOnboarding: "Continue onboarding",
};
